import React from "react";
import "./Home.css";
import getCookie from "../../utils/getCookie";
import handleLogout from "../../utils/handleLogout";
import { ENV } from "../../utils/env";

const Home = () => {
  let userDivisions = getCookie(`userDivisions.${ENV}`);
  if (userDivisions) {
    try {
      userDivisions = JSON.parse(decodeURIComponent(userDivisions));
    } catch (e) {
      userDivisions = [];
    }
  } else {
    userDivisions = [];
  }

  return userDivisions.length === 0 ? (
    <section className="home-container">
      <header className="home-header">
        <span className="home-heading">
          You do not have access to Bus Assignments
        </span>
        <button type="button" onClick={handleLogout} className="home-link home-link-button">
          Logout
        </button>
      </header>
    </section>
  ) : (
    <section className="home-container">
      <header className="home-header">
        <h3 className="home-heading">Bus Assignments</h3>
      </header>
      <a href="/FixedRoute" className="home-link">
        Fixed Route
      </a>
      <a href="/SpecialServices" className="home-link">
        Special Services
      </a>
    </section>
  );
};

export default Home;
